module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-progress-linear', {
    staticClass: "app-progress",
    attrs: {
      "active": _vm.$store.state.activeRequests.length,
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('v-content', [_c('v-flex', {
    staticClass: "alert"
  }, [_c('v-alert', {
    staticStyle: {
      "width": "max-content"
    },
    attrs: {
      "type": "error",
      "dismissible": "",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, _vm._l((_vm.$store.state.errorList), function(text) {
    return _c('p', [_vm._v(_vm._s(text))])
  }), 0)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-300f461e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./webapp/components/App.vue
// module id = 479
// module chunks = 0